import { connect } from 'react-redux';
import { Notification } from '../../components';
import { dismissNotification } from '../../redux/actions/notification';

const mapStateToProps = state => ({
  notification: state.notification.notification
});

const mapDispatchToProps = { dismissNotification };

export default connect(mapStateToProps, mapDispatchToProps)(Notification);



// WEBPACK FOOTER //
// ./src/Layouts/MainLayout/NotificationConnected.js